import React from 'react';
export function Hero() {
  return <section id="hero" className="relative overflow-hidden" style={{
    background: 'linear-gradient(160deg, var(--blush) 0%, var(--lilac) 50%, var(--nude-warm) 100%)'
  }} data-id="element-136">
      {/* Decorative circles */}
      <div className="absolute pointer-events-none" style={{
      width: '500px',
      height: '500px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(200,169,110,.18) 0%, transparent 65%)',
      top: '-100px',
      right: '-150px'
    }} data-id="element-137" />
      <div className="absolute pointer-events-none" style={{
      width: '320px',
      height: '320px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(180,122,138,.15) 0%, transparent 65%)',
      bottom: '-60px',
      left: '-80px'
    }} data-id="element-138" />

      <div className="relative z-10 max-w-[1000px] mx-auto px-5 md:px-10 py-10 pb-10 md:py-16 md:pb-14 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center" data-id="element-139">
        {/* Hero Image - shows first on mobile */}
        <div className="flex items-center justify-center md:order-2 order-first" data-id="element-140">
          <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BUNDLE.png?v=1772835860" alt="Kit Digital 33 Rituales para Soltar el Pasado — Bundle completo" className="w-full max-w-[320px] md:max-w-[420px] float-animation" style={{
          filter: 'drop-shadow(0 24px 48px rgba(180,118,138,.25))'
        }} data-id="element-141" />
        </div>

        {/* Hero Text */}
        <div className="md:order-1 text-center md:text-left" data-id="element-142">
          <span className="hero-animate hero-animate-1 inline-block text-[10px] font-medium tracking-[3.5px] uppercase py-[7px] px-[18px] mb-4 rounded-full" style={{
          background: 'rgba(200,169,110,.18)',
          border: '1px solid var(--gold)',
          color: 'var(--ink-soft)'
        }} data-id="element-143">
            Kit Digital · Liberación Emocional
          </span>

          <h1 className="hero-animate hero-animate-2 font-serif font-medium mb-2" style={{
          fontSize: 'clamp(32px, 5.5vw, 58px)',
          color: 'var(--ink)',
          lineHeight: 1.1
        }} data-id="element-144">
            Dejá ir lo que pesa.
            <br data-id="element-145" />
            <em style={{
            color: 'var(--rose-deep)',
            fontStyle: 'italic'
          }} data-id="element-146">
              Entrá liviana
            </em>
            <br data-id="element-147" />a lo que viene.
          </h1>

          <p className="hero-animate hero-animate-3 font-light my-4 mb-5" style={{
          fontSize: 'clamp(15px, 2.2vw, 19px)',
          color: 'var(--ink-soft)',
          lineHeight: 1.6
        }} data-id="element-148">
            Un{' '}
            <strong style={{
            color: 'var(--ink)',
            fontWeight: 500
          }} data-id="element-149">
              proceso guiado de escritura terapéutica y rituales simbólicos
            </strong>{' '}
            para que tu mente encuentre{' '}
            <u data-id="element-150">el cierre que lleva tiempo necesitando</u>.
          </p>

          <div className="hero-animate hero-animate-4 mb-6 rounded-r-lg text-left" style={{
          background: 'rgba(255,255,255,.55)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(200,169,110,.3)',
          borderLeft: '3px solid var(--gold)',
          padding: '16px 20px'
        }} data-id="element-151">
            <p className="font-serif italic" style={{
            fontSize: 'clamp(14px, 2vw, 17px)',
            color: 'var(--ink)',
            lineHeight: 1.5
          }} data-id="element-152">
              "No podés soltar algo que tu mente{' '}
              <strong style={{
              fontWeight: 500
            }} data-id="element-153">
                nunca tuvo permiso de cerrar
              </strong>
              . Este kit te da ese permiso."
            </p>
          </div>

          <div className="hero-animate hero-animate-5 flex items-center gap-4 flex-wrap mb-5 justify-center md:justify-start" data-id="element-154">
            <span className="text-[14px] line-through opacity-70" style={{
            color: 'var(--muted)'
          }} data-id="element-155">
              $56.970
            </span>
            <span className="font-serif text-[36px] font-bold leading-none" style={{
            color: 'var(--ink)'
          }} data-id="element-156">
              $14.990
            </span>
            <span className="text-[11px] font-medium tracking-[1.5px] uppercase py-[5px] px-3 rounded-full" style={{
            background: 'var(--rose-deep)',
            color: '#fff'
          }} data-id="element-157">
              73% off
            </span>
          </div>

          <div className="hero-animate hero-animate-6" data-id="element-158">
            <a href="#pricing" className="inline-block font-sans font-medium text-[12px] tracking-[2.5px] uppercase py-[16px] px-8 rounded no-underline relative overflow-hidden transition-all duration-300 hover:-translate-y-[3px]" style={{
            background: 'linear-gradient(135deg, var(--gold), var(--gold-shine), var(--gold))',
            backgroundSize: '200% 100%',
            color: 'var(--ink)',
            boxShadow: '0 6px 28px rgba(200,169,110,.4)'
          }} data-id="element-159">
              <span className="relative z-10" data-id="element-160">Quiero mi kit ahora </span>
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,.3), transparent 60%)'
            }} data-id="element-161" />
            </a>
            <span className="block text-center text-[11px] tracking-[0.5px] mt-2.5" style={{
            color: 'var(--muted)'
          }} data-id="element-162">
              Acceso inmediato · Garantía 7 días · Sin riesgo
            </span>
          </div>
        </div>
      </div>
    </section>;
}